if (!customElements.get('maxtiz-size-help')) {
  customElements.define('maxtiz-size-help', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.mx-size-guide__trigger');
      this.querySelector('.mx-size-guide__close').addEventListener('click', () => this.dialog.close());
      trigger.addEventListener('click', () => {
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right ||
            event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        trigger.focus({ preventScroll: true });
      });
    }
    disconnectedCallback() {
      if (this.dialog?.open) {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.dialog.close();
      }
    }
  });
}
